<soft-mengen-eingabe
  [(value)]="quantity"
  [minValue]="0"
  [einheit]="bewekomm()?.artikelMengeOffen?.einheit?.arteh ?? undefined"
  [maxValue]="bewekomm()?.artikelMengeOffen?.menge ?? Number.MAX_SAFE_INTEGER">
</soft-mengen-eingabe>
@if (bewekomm()?.artikelMengeOffen?.arteheingabe) {
  <button class="soft-link" (click)="openUnitEntryModal()">Mengeneingabe</button>
}


<div class="flex items-center gap-2 mt-2">
  <button class="soft-button secondary h-14 w-full rounded" (click)="resolve(undefined)">Abbrechen</button>
  <button class="soft-button primary h-14 w-full rounded" (click)="close()">Übernehmen</button>
</div>
